import {getSessionKey, ENV_KEY, TOKEN_EXPIRE_TIME, TOKEN_KEY} from './storage'

const CSC_API_TEST = 'https://connect.test.creditsafe.com/v1'
const CSC_API_STAGE = 'https://connect.stage.creditsafe.com/v1'
const CSC_API_LIVE = 'https://connect.creditsafe.com/v1'

export function fetchUrlBasedOnEnv (env = getSessionKey(ENV_KEY)) {
  if (env === 'live') {
    return CSC_API_LIVE
  } else if (env === 'stage') {
    return CSC_API_STAGE
  }
  return CSC_API_TEST
}

export function getTokenExpireTime () {
  let currentTime = new Date()
  let nextHourTime = currentTime.setHours(currentTime.getHours() + 1)
  return nextHourTime
}

export function getTokenExpireCountDown () {
  let expireTime = getSessionKey(TOKEN_EXPIRE_TIME)
  if (expireTime) {
    expireTime = parseFloat(expireTime)
    let countDown = (expireTime - (new Date().getTime())) / (1000 * 60)
    if (countDown > 1) {
      // adding 0.5, to make sure that we show the ceil value
      // eg: 59.3333 => 59
      // 59.5666 => 60
      return parseInt(countDown + 0.5, 10)
    } else if (countDown > 0) {
      return 1
    }
    return countDown
  }
  return 60
}

export function isAuthenticated () {
  let tokenFromSession = getSessionKey(TOKEN_KEY)
  if (tokenFromSession) {
    return true
  }
  return false
}

export function copyToClipboard (text, document) {
  let success = false
  if (text && document && typeof document === 'object') {
    // Create a "hidden" input
    let aux = document.createElement('input')
    // Assign it the value of the specified element
    aux.setAttribute('value', text)
    // Append it to the body
    document.body.appendChild(aux)
    // Highlight its content
    aux.select()
    // Copy the highlighted text
    success = document.execCommand('copy')
    // Remove it from the body
    document.body.removeChild(aux)
  }
  return success
}

export function mapUniqueOnlineCountries (countries = []) {
  let uniqueCountries = []
  let mappedCountryCodes = []
  countries.map((country) => {
    if (country && mappedCountryCodes.indexOf(country['countryIso2']) === -1) {
      let obj = {}
      obj['name'] = country['countryName']
      obj['value'] = country['countryIso2']
      obj['selected'] = false
      uniqueCountries.push(obj)
      mappedCountryCodes.push(country['countryIso2'])
    }
    return null
  })
  return uniqueCountries
}

export function format (label) {
  return (label.substring(0, 1).toUpperCase() + label.substring(1)).split(/(?=[A-Z])/).join(' ')
}



// WEBPACK FOOTER //
// ./src/util/helpers.js